import { AdminRO } from '@routellers/types/dist/admin/admin.ro';

import { ApiMethodDeclaration } from '..';

/** ID юзера */
type ParamsData = number;

type ResponseData = AdminRO;

export const remove: ApiMethodDeclaration<ParamsData, ResponseData> = (id) => ({
    url: `/admins/${id}`,
    method: 'DELETE',
});
